import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ptBR from './pt-BR.json';
import ptPT from './pt-PT.json';

export type Locale = 'pt-BR' | 'pt-PT';

const detectLocale = (): Locale => {
  if (typeof localStorage !== 'undefined') {
    const stored = localStorage.getItem('canapyra-locale');
    if (stored === 'pt-BR' || stored === 'pt-PT') return stored;
  }
  const nav = typeof navigator !== 'undefined' ? navigator.language : 'pt-BR';
  return nav.startsWith('pt-PT') ? 'pt-PT' : 'pt-BR';
};

void i18n.use(initReactI18next).init({
  resources: {
    'pt-BR': { translation: ptBR },
    'pt-PT': { translation: ptPT },
  },
  lng: detectLocale(),
  fallbackLng: 'pt-BR',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export const setLocale = (locale: Locale): void => {
  if (typeof localStorage !== 'undefined') localStorage.setItem('canapyra-locale', locale);
  void i18n.changeLanguage(locale);
};

export default i18n;
